import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// anyOf      : user needs at least ONE of these features (Admin role)
// requireUTV : also requires UTVMember = true
// openToSuperAdmin : false => super_admin is also checked against UTVMember only (Upload CSV case)
const ProtectedFeatureRoute = ({ children, anyOf = [], requireUTV = false }) => {
  const [status, setStatus] = useState("loading"); // loading | allowed | denied | noauth

  useEffect(() => {
    let alive = true;

    const check = async () => {
      const token = localStorage.getItem("superadmintoken");
      if (!token) return alive && setStatus("noauth");

      try {
        const res = await axios.get(`${BASE_URL}/lenskart/verify-token`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const user = res.data?.user;
        if (!res.data?.success || !user) return alive && setStatus("noauth");

        const role = user.role;
        const isUTV = !!user.UTVMember;
        const features = user.featureAccess || [];

        let allowed = false;
        if (role === "super_admin") allowed = true;
        else if (role === "Admin") allowed = anyOf.length === 0 || anyOf.some((f) => features.includes(f));

        if (allowed && requireUTV && !isUTV) allowed = false;

        if (!alive) return;
        if (!allowed) toast.error("You don't have access to this page", { toastId: "no-access" });
        setStatus(allowed ? "allowed" : "denied");
      } catch {
        localStorage.removeItem("superadmintoken");
        if (alive) setStatus("noauth");
      }
    };

    check();
    return () => { alive = false; };
  }, []);

  if (status === "loading") {
    return <div className="p-10 text-center text-gray-500 text-sm">Checking access...</div>;
  }
  if (status === "noauth") return <Navigate to="/lkart/superadmin/" replace />;
  if (status === "denied") return <Navigate to="/lkart/superadmin/view" replace />;
  return children;
};

export default ProtectedFeatureRoute;